import { useEffect, useRef, useState } from "react";

// Renders long product lists in chunks so mobile browsers never mount
// thousands of cards at once. Loads the next chunk when the sentinel
// scrolls near the viewport.
export function useIncrementalList(list, { step = 48, resetKey = "" } = {}) {
  const [count, setCount] = useState(step);
  const sentinelRef = useRef(null);

  useEffect(() => {
    setCount(step);
    if (typeof window !== "undefined") window.scrollTo({ top: 0 });
  }, [resetKey, step]);

  const total = list.length;
  const hasMore = count < total;

  useEffect(() => {
    const node = sentinelRef.current;
    if (!node || !hasMore) return;
    const io = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) setCount((c) => c + step);
      },
      { rootMargin: "800px 0px" }
    );
    io.observe(node);
    return () => io.disconnect();
  }, [hasMore, step]);

  return {
    visible: hasMore ? list.slice(0, count) : list,
    shown: Math.min(count, total),
    hasMore,
    sentinelRef,
    loadMore: () => setCount((c) => c + step),
  };
}
